// extracted by mini-css-extract-plugin
module.exports = {"article":"AboutUs_article__C2JZ_"};